<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增产品模板' : '编辑产品模板'"
      :visible="true"
      width="60%"
      :before-close="closeForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品类型" prop="productType">
              <el-select v-model="ruleForm.productType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in PRODUCT_TYPE_ENUM"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机器类型" prop="machineType">
              <el-select
                v-model="ruleForm.machineType"
                placeholder="请选择"
                @change="handleChangeMachineType"
              >
                <el-option
                  v-for="(item, index) in $AllMachineModelInfoList"
                  :key="index"
                  :label="item.machineTypeCnName"
                  :value="item.machineTypeCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="机器型号" prop="machineModel">
              <el-select
                v-model="ruleForm.machineModel"
                placeholder="请选择"
                style="width: 100%"
              >
                <template v-if="ruleForm.machineType">
                  <el-option
                    v-for="(item, index) in $AllMachineModelInfoList.find(
                      ele => ele.machineTypeCode === ruleForm.machineType
                    ).machineSpec"
                    :key="index"
                    :label="
                      item.machineModel + '【' + item.machineModelName + '】'
                    "
                    :value="item.machineModel"
                  >
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="name">
              <el-input v-model.trim="ruleForm.name" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品描述" prop="description">
              <el-input
                v-model.trim="ruleForm.description"
                :rows="3"
                maxlength="200"
                show-word-limit
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品定价" prop="defaultPrice">
              <el-input
                v-model.trim="ruleForm.defaultPrice"
                type="text"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品指令" prop="machineCommand">
              <el-input
                v-model.trim="ruleForm.machineCommand"
                placeholder="请输入正确的json格式数据"
                type="textarea"
              ></el-input>
              <template>
                <el-button type="text" @click="ishelpshow = true"
                  >指令说明</el-button
                >
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
        <div class="align-center">
          <el-button type="primary" @click="submitForm()">确定</el-button>
          <el-button @click="closeForm()">取消</el-button>
        </div>
      </el-form>
      <el-dialog
        width="40%"
        title="指令格式说明"
        :visible.sync="ishelpshow"
        append-to-body
      >
        <table class="my-table">
          <thead>
            <tr>
              <th class="bolder">洗衣机</th>
              <th class="bolder">烘干机</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>MDC</div>

                <div>{"cyLen":0,"deCy":1}</div>
                <div>cyLen：0-快洗，1-标准洗</div>
                <div>deCy：1-热水棉质,2-温水普通,3-冷水免烫,4-冷水精细</div>
                <div></div>
                <div>{"r2OnTime":10}</div>
                <div>r2OnTime：2号继电器打开时间,单位秒</div>
              </td>
              <td>
                <div>MDC</div>

                <div>{"cyLen":10,"deCy":1}</div>
                <div>cyLen：10-10分钟</div>
                <div>deCy：1-高温,2-中温,3-低温,4-精细</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>H7s</div>
                <div>{"sPrice":456,"deCyModifier":0,"deCy":2}</div>
                <div>deCy：1-热水棉质,2-温水普通,3-冷水免烫,4-冷水精细</div>
                <div></div>
                <div>{"r2OnTime":10}</div>
                <div>r2OnTime：2号继电器打开时间,单位秒</div>
              </td>
              <td>
                <div>H7s</div>
                <div>
                  {"sPrice":456,"noHeatCyTimeM":45,"tPrice":10,"hCdTime":3,"mCdTime":3,"lCdTime":3,"dCdTime":3,"topOffEn":0,"hTemp":160,"mTemp":155,"lTemp":145,"deliTemp":115,"topOffTimeM":10,"standCyTimeM":49,"deCy":2}
                </div>
                <div>standCyTimeM-10分钟</div>
                <div>deCy：1-高温,2-中温,3-低温,4-精细</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>quantum</div>
                <div>
                  {"sPrice":123,"topOffTimeM":10,"standCyTimeM":10,"noHeatCyTimeM":45,"hCdTime":3,"mCdTime":3,"lCdTime":3,"dCdTime":3,"topOffEn":0,"topOffTimeM":10,"hTemp":31,"mTemp":29,"lTemp":25,"deliTemp":19,"deCy":1}
                </div>
                <div>deCy：1-热水棉质,2-温水普通,3-冷水免烫,4-冷水精细</div>
                <div></div>
                <div>{"r2OnTime":10}</div>
                <div>r2OnTime：2号继电器打开时间,单位秒</div>
              </td>
              <td>
                <div>quantum</div>
                <div>
                  {"sPrice":123,"topOffTimeM":10,"standCyTimeM":10,"noHeatCyTimeM":45,"hCdTime":3,"mCdTime":3,"lCdTime":3,"dCdTime":3,"topOffEn":0,"topOffTimeM":10,"hTemp":31,"mTemp":29,"lTemp":25,"deliTemp":19,"deCy":1}
                </div>
                <div>standCyTimeM-10分钟</div>
                <div>deCy：1-高温,2-中温,3-低温,4-精细</div>
              </td>
            </tr>

            <tr>
              <td>
                <div>
                  <div>自研加液器</div>

                  <div>
                    channelIndexAddr的值三种4010=通道1,4014=通道2,4018=通道3，
                  </div>
                  <div>runSeconds=运行时间</div>
                  <div>waitSeconds=等待时间</div>
                  <div>command=1，就写1。</div>
                </div>
                <div>
                  例如： { "channelIndexAddr":4014, "runSeconds":5,
                  "waitSeconds":1, "command":1 }
                </div>
              </td>
              <td>
                <div></div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import enumObject from "../../../plugins/enum";
//import { mapGetters } from "vuex";
export default {
  props: ["isCreate", "productInfo", "machineModelList"],
  data() {
    return {
      ishelpshow: false,
      machineList: [],
      vendorsList: [],
      ruleForm: {
        productType: this.productInfo ? this.productInfo.productType : "",
        machineType: this.productInfo ? this.productInfo.machineType : "",
        machineModel: this.productInfo ? this.productInfo.machineModel : "",
        machineCommand: this.productInfo ? this.productInfo.machineCommand : "",
        name: this.productInfo ? this.productInfo.name : "",
        description: this.productInfo ? this.productInfo.description : "",
        defaultPrice: this.productInfo ? this.productInfo.defaultPrice : "",
        isdefault: this.productInfo ? this.productInfo.isdefault : "",
        isdisabled: this.productInfo ? this.productInfo.isdisabled : "",
        id: this.productInfo ? this.productInfo.id : 0,
        productTemplateid: this.productInfo
          ? this.productInfo.productTemplateid
          : "",
        vendorid: this.vendorid ? this.productInfo.vendorid : ""
      },
      rules: {
        productType: [{ required: true, message: "请输入产品" }],
        machineType: [{ required: true, message: "请输入机器类型" }],
        machineModel: [{ required: true, message: "请输入机器型号" }],
        machineCommand: [{ required: true, message: "请输入机器指令" }],
        name: [{ required: true, message: "产品名" }],
        defaultPrice: [
          { required: true, message: "请输入价格" },
          {
            pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
            message: "请输入正确价格"
          }
        ],
        description: [{ required: true, message: "请输入描述" }],
        vendorid: [{ required: true, message: "请输入加盟商" }]
      }
    };
  },
  methods: {
    handleChangeMachineType() {
      this.ruleForm.machineModel = "";
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let saveModel = {
            description: this.ruleForm.description,
            machineModel: this.ruleForm.machineModel,
            machineCommand: this.ruleForm.machineCommand,
            machineType: this.ruleForm.machineType,
            name: this.ruleForm.name,
            defaultPrice: this.ruleForm.defaultPrice,
            productType: this.ruleForm.productType
          };
          if (!this.isCreate) {
            saveModel.id = this.ruleForm.id;
            saveModel.productTemplateid = this.ruleForm.productTemplateid;
          }

          let key = this.isCreate ? "新增产品模板" : "编辑产品模板";
          this.$axios(this.$urlMapping[key], {
            data: saveModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  },
  computed: {
    PRODUCT_TYPE_ENUM() {
      return enumObject.PRODUCT_TYPE_ENUM.filter(ele => ele.value !== "");
    }
  },
  mounted() {
    this.$axios(this.$urlMapping["查询加盟商"], {
      data: {}
    }).then(result => {
      this.vendorsList = result.data;
    });
    this.machineList = this.machineModelList.slice(0);
    this.machineList.shift();
  }
};
</script>

<style lang="less" scoped>
.my-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  tr th,
  tr td {
    border: 1px solid #ccc;
    padding: 1rem;
    line-height: 20px;
  }
}
.bolder {
  font-weight: bold;
}
</style>
